import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import store from '../../store';
import setLocales from '../../store/setLocales';
import { Action } from '../../actions';
import { AppType } from './reducer';
import { openedFilesFolder } from '../../utils';
import { initializeMultiAppAuthentication } from '../MultiAppAuthentication/actions';
import { createNotification } from '../NotificationBar/actions';
import UserAgentUtils from '../../utils/userAgent';
import LocalStorageManager from '../../utils/localStorage/manager';
import NativeApi from '../../utils/nativeApi';
import AppTypeUtils from '../../utils/appType';

enum AppInfosActionKeys {
	ACCEPT_COOKIE = '@@app/ACCEPT_COOKIE',
	SET_APP_TYPE = '@@app/SET_APP_TYPE',
	SET_USER_LOCALE = '@@app/SET_USER_LOCALE'
}

interface AcceptCookieAction extends Action {
	type: AppInfosActionKeys.ACCEPT_COOKIE;
}

interface SetAppTypeAppAction extends Action {
	type: AppInfosActionKeys.SET_APP_TYPE;
	appType: AppType;
}

interface SetAppUserLocaleAction extends Action {
	type: AppInfosActionKeys.SET_USER_LOCALE;
	locale: string;
}

type AppInfosAction = AcceptCookieAction
	| SetAppTypeAppAction
	| SetAppUserLocaleAction;

const getAppType = (): AppType => {
	return AppTypeUtils.isMultiApp ?
		AppType.Multiple :
		AppType.Single;
};

const initializeApp = () => async (dispatch: Dispatch<StoreState>): Promise<void | {}> => {
	try {
		const appType = getAppType();
		dispatch({ type: AppInfosActionKeys.SET_APP_TYPE, appType });

		if (appType === AppType.Multiple) {
			dispatch(initializeMultiAppAuthentication());
		}

		// TODO: find a better way for removing openedFiles folder.
		// In current solution openedFiles folder exists and uses device space until next app launch
		// The best way to do it on app killing but there is no native api for it
		if (UserAgentUtils.isMobileApp) {
			const isOpenedFilesFolderExist = await NativeApi.existDirectory(openedFilesFolder);
			if (isOpenedFilesFolderExist) {
				NativeApi.deleteDirJs(`../../${openedFilesFolder}`);
			}
		}
	} catch (error) {
		dispatch(createNotification('error.initialization_fail'));
	}
};

const setUserLocale = (locale: string, hasPrefix: boolean, setLocalStorage: boolean = true) => (dispatch: Dispatch<StoreState>): void => {
	if (setLocalStorage) {
		LocalStorageManager.setUserLocale(locale, hasPrefix);
	}

	dispatch({ type: AppInfosActionKeys.SET_USER_LOCALE, locale });
	setLocales(store, locale);
};

const acceptCookie = (): AcceptCookieAction => ({
	type: AppInfosActionKeys.ACCEPT_COOKIE,
});

export { AppInfosActionKeys, AppInfosAction, initializeApp, setUserLocale, acceptCookie };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/actions.ts